import React from 'react'
import { Button, Popconfirm } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from './DeleteButton.module.scss'
import { DeleteOutlined } from '@ant-design/icons'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  canDeleteDepositsSelector,
  selectedDepositsSelector,
  removeDeposits,
} from 'src/features'

const DeleteButton = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const deleteValidation = useAppSelector(canDeleteDepositsSelector)
  const selectedDeposits = useAppSelector(selectedDepositsSelector)

  const handleConfirm = () => {
    const labels = {
      'EMPTY_ERROR': t('Deposits.NoSelectedError'),
      'ONLY_PENDING_ERROR': t('Deposits.OnlyPendingError')
    }
    if (deleteValidation !== 'SUCCESS') {
      showNotification('error', labels[deleteValidation])
      return
    }
    dispatch(removeDeposits(selectedDeposits))
  }

  return (
    <Popconfirm
      title={t('Deposits.RemoveConfirm')}
      onConfirm={handleConfirm}
      okText={t('general.Yes')}
      cancelText={t('general.Cancel')}
    >
      <Button
        block
        icon={<DeleteOutlined />}
        className={styles['button']}
      >
        {t('Deposits.Remove')}
      </Button>
    </Popconfirm>
  )
}

export default DeleteButton
